import React from "react";
import { useMessageSource } from "react-message-source";
import "./styles.scss";
import { ApplicationChapter, StepperProps } from "./types";
import CustomTypography from "../../../widgets/typography";

export default function FlowStepper({
  chapters,
  activeChapterId,
}: StepperProps): React.JSX.Element {
  const { getMessage } = useMessageSource();

  const activeChapterIndex = chapters.findIndex(
    (step: ApplicationChapter) => step.id === activeChapterId,
  );

  const resolveChapterClassname = (chapterIndex: number): string | null => {
    if (chapterIndex === activeChapterIndex) {
      return "active";
    }
    if (chapterIndex > activeChapterIndex) {
      return "disabled";
    }
    if (chapterIndex < activeChapterIndex) {
      return "completed";
    }

    return null;
  };

  return (
    <aside className="scd-stepper-nav">
      <ul className="scd-stepper-list">
        {chapters.map((chapter, index) => {
          return (
            <li
              className={`step-item scd-typography-wrapper ${resolveChapterClassname(
                index,
              )}`}
              key={chapter.id}
            >
              <div className="step-count">
                {getMessage("Stepper.count-step", index + 1, chapters.length)}
              </div>
              <i className="icon-scd-check" />
              <CustomTypography
                variant="body2"
                className="scd-step-header"
                key={index}
              >
                {chapter.title}
              </CustomTypography>
            </li>
          );
        })}
      </ul>
    </aside>
  );
}
